export default "__VITE_ASSET__Q3oqusj8__"